import { styled } from '@mui/material/styles';
import FormGroup from '@mui/material/FormGroup';
import COLORS from '../../styles/theme/colors';

export const Item = styled('div')({
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  borderBottom:' 0.4px solid #D5D5D5',
  padding: '0 33px 10px',

  '&:last-child': {
    borderBottom: 'none'
  }
});

export const ItemTitle = styled('h4')({
  color: COLORS.textSecondColor,
  margin: '10px 0 0',
  fontWeight: '500',
  fontSize: 16
});

export const Content = styled(FormGroup)({
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'row',
  width: '100%',
  flexWrap: 'wrap',

  '& .MuiFormControlLabel-root': {
    flex: 1,
    minWidth: '45%',
    color: COLORS.textColor,
    fontWeight: 400,    
    fontSize: 16
  }
});
